<corp-pop-menu>
    <ng-template #trigger>
        <button 
            content-pop-trigger
            dropdown-button 
            class="relative top-[2px] transition-all hover:text-primary-500" 
            id="connectedAppsMenuBtn" 
            (click)="toggleMenu()" 
            [class.active]="menuOpen">
            <i class="material-symbols-outlined !text-[22px] md:!text-xl">
                apps
            </i>
        </button>
    </ng-template>

    <ng-template #content>
        <div class="connected-apps-dropdown shadow-3xl absolute top-full top-full right-0 left-0 z-[1] mt-[9px] w-[375px] rounded-md bg-white px-[10px] pt-[20px] pb-[5px] transition-all md:mt-[20px] md:px-[15px] md:pt-[25px] md:pb-[8px] dark:bg-[#0c1427] dark:shadow-none">
            <ul class="grid grid-cols-5 gap-[5px] text-center">
                @for(appUserRole of userInfo?.appUserRoles; track appUserRole.appId) {
                @if(appUserRole && appUserRole.isApp) {

                <li>
                    <a [href]="appUserRole?.url + '/' + appUserRole.appId" class="mb-[15px] block text-xs text-black transition-all hover:text-primary-500 dark:text-white" target="_blank">
                        <img [src]="'/cdn/assets/logo/apps/' + appUserRole.appId + '.png'"
                             class="inline-block h-[30px] w-[30px]"
                             [alt]="appUserRole.appId">
                        <span class="mt-[7px] block">
                            {{ appUserRole.appId }}
                        </span>
                    </a>
                </li>
                }
                }
            </ul>
        </div>
    </ng-template>
</corp-pop-menu>









